import _ from 'lodash';
import {fromJS, Map} from 'immutable';
import '../../libraries';

import { ADD_ITEM, FIX_SELECTION, REMOVE_ITEM, REMOVE_ITEM_SELECTION, SET_ITEMS, SET_SELECTED_ITEMS, TOGGLE_ITEM, TOGGLE_ITEM_SELECTION, addItem, fixSelection, removeItem, removeItemSelection, setItems, setSelectedItems, toggleItem, toggleItemSelection} from './actions';

export function mainReducer(state = new Map(), action) {
    if (!state.get('items'))
        state = state.set('items', new Map());
    if (!state.get('current'))
        state = state.set('current', new Map());

    switch (action.type) {
    case SET_ITEMS:
        if (state.getIn(['items', action.resource]) === 0 && action.payload === 0)
            throw new Error('Already fetching');
        const items = action.payload === 0 ? 0 : action.payload instanceof Map
            ? action.payload
            : fromJS(_.mapKeys(action.payload, item => item.id)).mapKeys(key => String(key));
        state = state.setIn(['items', action.resource], items);
        break;

    case ADD_ITEM:
        state = state.setIn(
            ['items', action.resource, String(action.payload.id)],
            fromJS(action.payload),
        );
        break;

    case REMOVE_ITEM:
        state = state.removeIn(
            ['items', action.resource, String(action.payload.id)],
        );
        break;

    // case UPDATE_ITEM: 
    //     state = state.updateIn(
    //         [
    //             'items',
    //             action.resource,
    //             state.get('items').get(action.resource).findIndex(
    //                 item => item.get('id') == action.payload.id,
    //             ),
    //         ],
    //         () => fromJS(action.payload),
    //     );
    //     break;
    }

    window.items = state.get('items');
    return state;
}

export default function(state = fromJS({elementId: window.uuidv4()}), action) {
    if (!state.get('selected'))
        state = state.set('selected', new Map());
    if (!state.get('selected_data'))
        state = state.set('selected_data', new Map());
    if (!state.get('opened'))
        state = state.set('opened', new Map());

    if (action.elementId !== state.get('elementId')) {
        return state;
    }

    let items = window.items.get(action.resource);

    function parentRoot(item, items) {
        if (!item)
            return '';
        if (!item.get('parent'))
            return item.get('label');
        return parentRoot(
            items.get(String(item.get('parent'))),
        ) + ' ← ' + item.get('label');
    }

    function parentRoot_data(item, items) {
        if (!item)
            return null;
        if (!item.get('parent'))
            return item;
        return parentRoot(
            items.get(String(item.get('parent'))),
        ) + ' ← ' + item;
    }


    switch (action.type) {
    case SET_ITEMS: {
        if (action.payload !== 0) {
            items = action.payload instanceof Map ? action.payload : fromJS(_.mapKeys(action.payload, item => item.id)).mapKeys(key => String(key));
            if (state.get('selected').contains(null)) {
                state = state.set(
                    'selected',
                    state.get('selected').mapEntries(
                        entry => [
                            entry[0],
                            items.get(String(entry[0]))
                                ? parentRoot(items.get(String(entry[0])), items)
                                : entry[1],
                        ],
                    ),
                );
                state = state.set(
                    'selected_data',
                    state.get('selected_data').mapEntries(
                        entry => [
                            entry[0],
                            items.get(String(entry[0]))
                                ? parentRoot_data(items.get(String(entry[0])), items)
                                : entry[1],
                        ],
                    ),
                );
            }
        }
        break;
    }

    case FIX_SELECTION:
        if (items?.size > 0 && state.get('selected').find((value, key) => !items.has(String(key)))) {
            state = state.set(
                'selected',
                state.get('selected').filter(
                    (value, key) =>
                        items.has(String(key)),
                ),
            );
            state = state.set(
                'selected_data',
                state.get('selected_data').filter(
                    (value, key) =>
                        items.has(String(key)),
                ),
            );
        }
        break;

    case TOGGLE_ITEM:
        const id = action.payload instanceof Object ? action.payload.id : action.payload;
        state = state.updateIn(
            ['opened'], new Map(), opened => opened.set(id, !opened.get(id, false)),
        );
        break;

    case SET_SELECTED_ITEMS:
        const selection = _.mapValues(
            _.mapKeys(action.payload),
            id => items && items.get(String(id))
                ? parentRoot(items.get(String(id)), items)
                : null,
        );
        const selection_data = _.mapValues(
            _.mapKeys(action.payload),
            id => items && items.get(String(id))
                ? parentRoot_data(items.get(String(id)), items)
                : null,
        );
        state = state.set(
            'selected',
            fromJS(selection),
        );
        state = state.set(
            'selected_data',
            fromJS(selection_data),
        );
        break;

    case TOGGLE_ITEM_SELECTION: {
        const id = action.payload instanceof Object ? String(action.payload.id) : String(action.payload);
        if (state.get('selected').has(id)) {
            state = state.removeIn(['selected', id]);
            state = state.removeIn(['selected_data', id]);
        }
        else {
            state = state.setIn(
                ['selected', id],
                parentRoot(items.get(id), items),
            );
            state = state.setIn(
                ['selected_data',id],
                action.payload,
            );
        }
        break;
    }

    case REMOVE_ITEM_SELECTION: {
        const id = String(action.payload);
        state = state.removeIn(
            ['selected', id],
        );
        state = state.removeIn(
            ['selected_data', id],
        );
        break;
    }
    }
    return state;
}
